// High-score hub configuration.
// HUB is env-driven: a local hub in development (see .env.development), and the
// production hub as a baked-in fallback. Never hardcode the URL elsewhere.
export const HUB = process.env.REACT_APP_HUB_URL ?? "https://pokervane.com";

// Fixed game namespace; the hub allowlists this exact value.
export const GAME = "poker_patience";

// localStorage keys.
export const NAME_KEY = "pp_hs_name"; // last username used
export const TOKEN_KEY = "pp_hs_token"; // device token proving name ownership
export const PW_SET_KEY = "pp_hs_pw_set"; // "1" if this name was claimed with a password
